<template>
  <div class="choose-page">
    <div class="grid">
      <div
        class="card"
        v-for="item in datalist"
        :key="item.id"
        @click="toDetail(item.id)"
      >
        <div class="pic">
          <img :src="item.img_url" :alt="item.xuanfei_name" />
        </div>
        <div class="name">{{ item.xuanfei_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datalist: [],
    };
  },
  methods: {
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id } });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const list = (res && res.data) || [];
        this.datalist = (Array.isArray(list) ? list : []).map((item) => ({
          ...item,
          img_url:
            typeof item.img_url === "string"
              ? item.img_url
              : Array.isArray(item.img_url)
              ? item.img_url[0]
              : item.img || "",
        }));
      });
    },
  },
  created() {
    this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.choose-page {
  min-height: 100vh;
  background: #000000;
  padding: 12px 10px 130px;
  box-sizing: border-box;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.card {
  background: #141414;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 8px;
  box-sizing: border-box;
}

.pic {
  width: 100%;
  aspect-ratio: 1 / 1.05;
  border-radius: 6px;
  overflow: hidden;
  background: #eee;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.name {
  margin-top: 8px;
  padding: 0 2px 2px;
  font-size: 15px;
  line-height: 1.3;
  color: #222;
  font-weight: 500;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
